// extracted by mini-css-extract-plugin
module.exports = {"link":"KSV_link__0NFMP","ksvLogo":"KSV_ksvLogo__DI0nT"};